import api from "./client";

export async function resolveMaterialVariant({ material_id, selections, optional_dimension_ids = [] }) {
  const res = await api.post("/material-variants/resolve", {
    material_id,
    selections,
    optional_dimension_ids,
  });
  return res.data.data;
}

